import React, { FC } from "react"
import { Visible } from "react-grid-system"
import Mobile from "./Mobile"
import Web from "./Web"
import Section from "@/components/Section"
import { useTranslation } from "react-i18next"

interface Props {
  light?: boolean
  TitleComponent?: React.ReactElement
}

const CompanyValues: FC<Props> = ({ light = false, TitleComponent }) => {
  const { t } = useTranslation("values")

  return (
    <Section
      light={light}
      TitleComponent={
        TitleComponent
          ? () => <TitleComponent>{t("common.title")}</TitleComponent>
          : undefined
      }
      id="values"
    >
      <Visible xs sm>
        <Mobile light={light} />
      </Visible>
      <Visible md lg xl xxl>
        <Web light={light} />
      </Visible>
    </Section>
  )
}

export default CompanyValues
